/* ============================================================
   THE CARAZON — MAIN JAVASCRIPT
   ============================================================ */

'use strict';

/* ============================================================
   ANNOUNCEMENT BAR — auto-rotate & close
   ============================================================ */
(function initAnnouncement() {
    const bar    = document.getElementById('announcementBar');
    const close  = document.getElementById('announcementClose');
    const items  = bar ? bar.querySelectorAll('.announcement-item') : [];
    let current  = 0;
    let interval;

    if (!bar || items.length === 0) return;

    function showItem(index) {
        items.forEach((el, i) => {
            el.classList.toggle('active', i === index);
        });
    }

    function next() {
        current = (current + 1) % items.length;
        showItem(current);
    }

    showItem(0);
    interval = setInterval(next, 4500);

    if (close) {
        close.addEventListener('click', function () {
            bar.classList.add('is-hidden');
            clearInterval(interval);
            // Adjust header top
            const header = document.getElementById('siteHeader');
            if (header) header.style.top = '0';
        });
    }
})();

/* ============================================================
   STICKY HEADER — add class on scroll
   ============================================================ */
(function initStickyHeader() {
    const header = document.getElementById('siteHeader');
    if (!header) return;

    let ticking = false;

    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(function () {
                const scrolled = window.scrollY > 80;
                header.classList.toggle('is-scrolled', scrolled);
                ticking = false;
            });
            ticking = true;
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
})();

/* ============================================================
   MOBILE NAVIGATION — toggle overlay
   ============================================================ */
(function initMobileNav() {
    const toggle  = document.getElementById('navToggle');
    const overlay = document.getElementById('mobileNavOverlay');
    const closeBtn = document.getElementById('mobileNavClose');

    if (!toggle || !overlay) return;

    function open() {
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        toggle.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    }

    function close() {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        toggle.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function () {
        overlay.classList.contains('is-open') ? close() : open();
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    // Close on backdrop click
    overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
})();

/* ============================================================
   SCROLL REVEAL — intersection observer
   ============================================================ */
(function initReveal() {
    const elements = document.querySelectorAll('.reveal');
    if (!elements.length) return;

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, {
        rootMargin: '0px 0px -60px 0px',
        threshold: 0.08
    });

    elements.forEach(function (el) {
        observer.observe(el);
    });
})();

/* ============================================================
   EMAIL FORMS — capture & footer
   ============================================================ */
(function initEmailForms() {
    function handleSubmit(form, inputSelector) {
        if (!form) return;

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            const input = form.querySelector('input[type="email"]');
            if (!input) return;

            const email = input.value.trim();
            if (!email || !isValidEmail(email)) {
                showFormError(input, 'Please enter a valid email address.');
                return;
            }

            // Replace with your actual email service integration
            const btn = form.querySelector('button[type="submit"]');
            const originalText = btn ? btn.textContent : '';

            if (btn) {
                btn.textContent = 'Sending…';
                btn.disabled = true;
            }

            // Simulate API call (replace with real integration)
            setTimeout(function () {
                showFormSuccess(form, 'You\'re in! Check your inbox for your free guide.');
                input.value = '';
                if (btn) {
                    btn.textContent = originalText;
                    btn.disabled = false;
                }
            }, 1200);
        });
    }

    handleSubmit(document.getElementById('emailCaptureForm'));
    handleSubmit(document.getElementById('footerEmailForm'));

    function isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function showFormError(input, message) {
        input.style.borderColor = '#C0392B';
        input.setAttribute('aria-invalid', 'true');

        let msg = input.parentElement.querySelector('.form-msg');
        if (!msg) {
            msg = document.createElement('p');
            msg.className = 'form-msg';
            msg.style.cssText = 'font-size:0.78rem; color:#C0392B; margin-top:0.35rem;';
            input.parentElement.appendChild(msg);
        }
        msg.textContent = message;

        setTimeout(function () {
            input.style.borderColor = '';
            input.removeAttribute('aria-invalid');
            if (msg) msg.remove();
        }, 3000);
    }

    function showFormSuccess(form, message) {
        const successMsg = document.createElement('p');
        successMsg.style.cssText = 'font-size:0.9rem; color: #B8943F; font-weight:500; margin-top:0.5rem; text-align:center;';
        successMsg.textContent = '✓ ' + message;
        form.appendChild(successMsg);

        setTimeout(function () {
            successMsg.remove();
        }, 5000);
    }
})();

/* ============================================================
   SMOOTH SCROLL — anchor links
   ============================================================ */
(function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
            const targetId = this.getAttribute('href').slice(1);
            const target = document.getElementById(targetId);
            if (!target) return;

            e.preventDefault();
            const offset = 80; // account for sticky header
            const top = target.getBoundingClientRect().top + window.scrollY - offset;

            window.scrollTo({ top: top, behavior: 'smooth' });
        });
    });
})();

/* ============================================================
   MEGA MENU — keyboard accessibility
   ============================================================ */
(function initMegaMenu() {
    const dropdowns = document.querySelectorAll('.has-dropdown');

    dropdowns.forEach(function (item) {
        const trigger = item.querySelector('.nav-link');
        const menu    = item.querySelector('.mega-menu');
        if (!trigger || !menu) return;

        // Keyboard: open on Enter/Space, close on Escape
        trigger.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const isOpen = menu.style.opacity === '1';
                // Toggle visibility via inline style for keyboard users
                if (isOpen) {
                    menu.style.opacity = '';
                    menu.style.visibility = '';
                } else {
                    menu.style.opacity = '1';
                    menu.style.visibility = 'visible';
                }
            }
            if (e.key === 'Escape') {
                menu.style.opacity = '';
                menu.style.visibility = '';
                trigger.focus();
            }
        });
    });
})();

/* ============================================================
   PRODUCT PAGE — Quantity Selector
   ============================================================ */
(function initQuantitySelector() {
    var minusBtns = document.querySelectorAll('.pdp-qty-minus');
    var plusBtns  = document.querySelectorAll('.pdp-qty-plus');

    minusBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var input = this.parentElement.querySelector('.pdp-qty-input');
            if (!input) return;
            var val = parseInt(input.value, 10) || 1;
            if (val > 1) input.value = val - 1;
        });
    });

    plusBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var input = this.parentElement.querySelector('.pdp-qty-input');
            if (!input) return;
            var val = parseInt(input.value, 10) || 1;
            var max = parseInt(input.getAttribute('max'), 10) || 99;
            if (val < max) input.value = val + 1;
        });
    });
})();

/* ============================================================
   PRODUCT PAGE — Image Gallery (thumbnail swap)
   ============================================================ */
(function initPdpGallery() {
    var thumbs = document.querySelectorAll('.pdp-thumb');
    var mainImg = document.getElementById('pdpMainImage');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
            var src = this.getAttribute('data-full-src');
            var alt = this.getAttribute('data-alt') || '';
            if (!src) return;

            // Fade out, swap, fade in
            mainImg.style.opacity = '0.4';
            setTimeout(function () {
                mainImg.setAttribute('src', src);
                mainImg.setAttribute('alt', alt);
                mainImg.style.opacity = '1';
            }, 200);

            // Update active state
            thumbs.forEach(function (t) { t.classList.remove('is-active'); });
            this.classList.add('is-active');
        });
    });
})();

/* ============================================================
   PRODUCT PAGE — See More / See Less toggle
   ============================================================ */
(function initSeeMore() {
    var btn = document.getElementById('pdpSeeMore');
    var full = document.getElementById('pdpDescFull');
    if (!btn || !full) return;

    var section = btn.closest('.pdp-desc-section');
    var textEl = btn.querySelector('.pdp-desc-see-more-text');
    var isOpen = false;

    btn.addEventListener('click', function () {
        isOpen = !isOpen;
        full.classList.toggle('is-expanded', isOpen);
        if (section) section.classList.toggle('is-open', isOpen);
        if (textEl) textEl.textContent = isOpen ? 'See Less' : 'See More';
    });
})();

/* ============================================================
   UTILITY — check reduced motion preference
   ============================================================ */
(function respectReducedMotion() {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced) {
        // Disable animations for users who prefer reduced motion
        document.querySelectorAll('.reveal').forEach(function (el) {
            el.classList.add('is-visible');
        });

        document.querySelectorAll('.fade-in').forEach(function (el) {
            el.style.animationDuration = '0.001ms';
        });
    }
})();
